module.exports = __webpack_public_path__ + "media/images/trolley_red-6a65ab50389eec7476212e3769514251.svg";